import React, { Component } from "react";
import '../css/documentation.scss';

export class EditKinoloungeHelp extends Component {
    render() {
        return (
            <div className="main-content">
                <div className="section__content section__content--p30 createContent">
                    <div className="container-fluid">
                        <h1 style={{ fontSize: '36px', marginTop: '30px' }}>How To Edit Kinolounge</h1>
                        <p className="dateFormat" style={{ fontSize: '14px', color: 'grey' }}>18/11/2021 ▪ 5 minutes to read</p>
                        <br /><br />
                        <div class="webMgmt container-fluid">
                            <ol>
                                <li class="createList">
                                    Using the menu on the left, click on "Website Management", then click on the "Kinolounge" link. This will take you to the Kinolounge Listing Page.<br />
                                    <img src="/img/documentation-img/KinoImg/nav.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    In the Kinolounge Listing Page, click on any kinolounge listing of your choice. This will take you to the View Kinolounge Details. <br />
                                    <img src="/img/documentation-img/KinoImg/list_select.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    To edit the kinolounge listing, click on the “Edit” button in the top right corner of the page.<br />
                                    <img src="/img/documentation-img/KinoImg/view_edit.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    In Edit Kinolounge Page, you will be able to see the following fields:
                                    <ul class="unorderedList">

                                        <li>
                                            Movie ID
                                        </li>
                                        <li>
                                            Movie Title
                                        </li>
                                        <li>
                                            Display Start On
                                        </li>
                                        <li>
                                            Display End On
                                        </li>
                                        <li>
                                            Movie Runtime
                                        </li>
                                        <li>
                                            Movie Rating
                                        </li>
                                        <li>
                                            Display Weight
                                        </li>
                                        <li>
                                            Is Collection
                                        </li>
                                        <li>
                                            Collection Description (only shown when Is Collection is checkedd)
                                        </li>
                                        <li>
                                            Poster URL
                                        </li>

                                        <li>
                                            Movie URL
                                        </li>

                                    </ul>
                                    <div class="alert alert-primary" role="alert">
                                        <i class="fas fa-info-circle" aria-hidden="true"></i>
                                        <strong class="noteHeader">Information:</strong><br/><br/>
                                            - Display weight determines how the item will be displayed. The lower the display weight, the higher it will place on the website.<br />
                                            - Display Start On should always be earlier than Display End On.<br />
                                            - If Is Collection is unchecked, there will be no Collection Description field.<br />
                                            - Collection Description should be in HTML format.<br />
                                            - Collection Description should have a maximum of 250 characters
                                </div>
                            </li>

                                <li class="createList">
                                            To preview the poster image, click on 'Preview'.<br />
                                            <img src="/img/documentation-img/KinoImg/edit_preview.png" class="userImage" />
                                        </li>
                                <li class="createList">
                                            To close the preview, click on the 'X' at the top right corner.<br />
                                            <img src="/img/documentation-img/KinoImg/preview_close.png" class="userImage" />
                                        </li>
                                <li class="createList">
                                            To save your changes, click on “Save Changes” at the bottom right corner of the page. <br />
                                            <img src="/img/documentation-img/KinoImg/edit_save.png" class="userImage" />
                                        </li>
                                <li class="createList">
                                            To confirm that you would like to save your changes, click on the “Confirm” button.<br />
                                            <img src="/img/documentation-img/KinoImg/edit_save_confirm.png" class="userImage" />
                                        </li>
                                <li class="createList">
                                            Upon successful save, a confirmation message will appear at the bottom right of the screen. <br />
                                            <img src="/img/documentation-img/KinoImg/edit_success.png" class="userImage" />
                                        </li>
                                <li class="createList">
                                            To cancel all changes, click on the “Cancel” button at the bottom right corner. <br />
                                            <img src="/img/documentation-img/KinoImg/edit_cancel.png" class="userImage" />
                                        </li>
                                <li class="createList">
                                            To confirm that you want to cancel all changes, click on "Confirm".<br />
                                            <img src="/img/documentation-img/KinoImg/edit_cancel_confirm.png" class="userImage" />
                                        </li>
                                <li class="createList">
                                            To view history changes, click on the "History” button, at the top right corner of the page. <br />
                                            <img src="/img/documentation-img/KinoImg/view_history.png" class="userImage" />
                                        </li>
                                <li class="createList">
                                            A popup will appear, stating the changes made. Click on "view details” to see more or “X” to close the popup.<br />
                                            <img src="/img/documentation-img/KinoImg/history_view.png" class="userImage" />
                                        </li>
                                <li class="createList">
                                            A pop-up will appear, stating the old and new values.<br />
                                            <img src="/img/documentation-img/KinoImg/historydetails.png" class="userImage" />
                                        </li>
                            </ol>
                            <div className="text-right">
                                <a href="/documentation/kinolounge/CreateKinoloungeHelp" className="btn btn-primary">&laquo; Create Kinolounge</a>&nbsp;
                            </div>
                        </div>
                    </div>
                </div>
                </div>
        );
    }
}